import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { featuredMovies } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const count = featuredMovies.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % count), 5000);
    return () => clearInterval(timer);
  }, [count]);

  const current = featuredMovies[index];

  const prev = () => setIndex((i) => (i - 1 + count) % count);
  const next = () => setIndex((i) => (i + 1) % count);

  return (
    <section className="relative h-[420px] w-full overflow-hidden md:h-[600px]" aria-label="热门推荐轮播">
      {featuredMovies.map((movie, i) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
          aria-hidden={i !== index}
        >
          <img
            src={movie.backdrop}
            alt={`${movie.title}剧照`}
            title={`${movie.title} ${movie.genres.join(" ")}`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent" />

      <div className="relative mx-auto flex h-full w-full max-w-[1280px] items-center px-4 md:px-6">
        <div key={current.id} className="animate-fade-up max-w-xl">
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <span className="rounded bg-accent-500 px-2 py-1 text-xs font-semibold text-background-50">焦点推荐</span>
            {current.genres.map((g) => (
              <span key={g} className="rounded border border-background-300 bg-background-100/70 px-2 py-1 text-xs text-foreground-700">
                {g}
              </span>
            ))}
          </div>
          <h1 className="text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">{current.title}</h1>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            {current.year} · {current.region} · {current.duration} · 评分 {current.rating.toFixed(1)}
          </p>
          <p className="mt-4 line-clamp-3 max-w-lg text-sm leading-relaxed text-foreground-500 md:text-base">
            {current.synopsis}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${current.id}`}
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-play-fill text-lg" />
              立即观看
            </Link>
            <Link
              to={`/detail/${current.id}`}
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100/60 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
            >
              <i className="ri-information-line text-lg" />
              查看详情
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={prev}
        aria-label="上一张"
        className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-300/60 bg-background-100/70 text-foreground-950 backdrop-blur transition-colors hover:bg-primary-500 hover:text-background-50 md:left-6"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={next}
        aria-label="下一张"
        className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-300/60 bg-background-100/70 text-foreground-950 backdrop-blur transition-colors hover:bg-primary-500 hover:text-background-50 md:right-6"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {featuredMovies.map((movie, i) => (
          <button
            key={movie.id}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`查看第${i + 1}张`}
            className={`h-1.5 rounded-full transition-all ${i === index ? "w-8 bg-accent-500" : "w-3 bg-background-400 hover:bg-background-500"}`}
          />
        ))}
      </div>
    </section>
  );
}